import { render, staticRenderFns } from "./photoSelector.vue?vue&type=template&id=68409f38&"
import script from "./photoSelector.vue?vue&type=script&lang=babel&"
export * from "./photoSelector.vue?vue&type=script&lang=babel&"
import style0 from "./photoSelector.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
